import { render, staticRenderFns } from "./EditBestelling.vue?vue&type=template&id=6e5e30ee&scoped=true&"
import script from "./EditBestelling.vue?vue&type=script&lang=js&"
export * from "./EditBestelling.vue?vue&type=script&lang=js&"
import style0 from "./EditBestelling.vue?vue&type=style&index=0&id=6e5e30ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5e30ee",
  null
  
)

export default component.exports